// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3u5YU","rootSmall":"AddTileButton_rootSmall__2IoJp"};